// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettingsNav-module__font-s-10___tsQVZ {
  font-size: 10px !important;
}

.SettingsNav-module__font-s-12___WRvLY {
  font-size: 12px !important;
}

.SettingsNav-module__font-s-13___Y_eOl {
  font-size: 13px !important;
}

.SettingsNav-module__font-s-14___yJC0v {
  font-size: 14px !important;
}

.SettingsNav-module__font-s-15___LJjcc {
  font-size: 15px !important;
}

.SettingsNav-module__font-s-16___C0juE {
  font-size: 16px !important;
}

.SettingsNav-module__font-s-18___ivtWK {
  font-size: 18px !important;
}

.SettingsNav-module__font-s-20___TwNCL {
  font-size: 20px !important;
}

.SettingsNav-module__font-s-22___y_7OX {
  font-size: 22px !important;
}

.SettingsNav-module__font-s-28___siAVF {
  font-size: 28px !important;
}

.SettingsNav-module__font-w-400___lD0VM {
  font-weight: 400 !important;
}

.SettingsNav-module__font-w-500___mjPBm {
  font-weight: 500 !important;
}

.SettingsNav-module__font-w-600___j7Ng_ {
  font-weight: 600 !important;
}

.SettingsNav-module__font-w-700___tyKpa {
  font-weight: 700 !important;
}

.SettingsNav-module__p-5___JsQyk {
  padding: 5px !important;
}

.SettingsNav-module__p-12___v1Fhm {
  padding: 12px !important;
}

.SettingsNav-module__p-16___JMjBi {
  padding: 16px !important;
}

.SettingsNav-module__p-30___dZ6yN {
  padding: 30px !important;
}

.SettingsNav-module__p-b-0___ZMYEm {
  padding-bottom: 0 !important;
}

.SettingsNav-module__p-b-5___GO1Ik {
  padding-bottom: 5px !important;
}

.SettingsNav-module__p-b-10___Kgcd3 {
  padding-bottom: 10px !important;
}

.SettingsNav-module__p-b-12___CnWxa {
  padding-bottom: 12px !important;
}

.SettingsNav-module__p-b-16___r9GyU {
  padding-bottom: 16px !important;
}

.SettingsNav-module__p-b-18___FuB84 {
  padding-bottom: 18px !important;
}

.SettingsNav-module__p-b-20___CrxZG {
  padding-bottom: 20px !important;
}

.SettingsNav-module__p-b-25___kSVIz {
  padding-bottom: 25px !important;
}

.SettingsNav-module__p-b-30___pHdba {
  padding-bottom: 30px !important;
}

.SettingsNav-module__p-b-50___Xar5q {
  padding-bottom: 50px !important;
}

.SettingsNav-module__p-t-0___eUX9_ {
  padding-top: 0 !important;
}

.SettingsNav-module__p-t-12___hAipe {
  padding-top: 12px !important;
}

.SettingsNav-module__p-t-16___PWV5B {
  padding-top: 16px !important;
}

.SettingsNav-module__p-t-18___Kvomf {
  padding-top: 18px !important;
}

.SettingsNav-module__p-t-20___DNtQ5 {
  padding-top: 20px !important;
}

.SettingsNav-module__p-t-30___f8qln {
  padding-top: 30px !important;
}

.SettingsNav-module__p-t-40___b1uwU {
  padding-top: 40px !important;
}

.SettingsNav-module__p-t-50___XAuHj {
  padding-top: 50px !important;
}

.SettingsNav-module__p-l-20___i39Md {
  padding-left: 20px !important;
}

.SettingsNav-module__p-l-30___wAv7E {
  padding-left: 30px !important;
}

.SettingsNav-module__p-l-40___HcReb {
  padding-left: 40px !important;
}

.SettingsNav-module__p-r-16___xU5Of {
  padding-right: 16px !important;
}

.SettingsNav-module__p-r-20___SglaR {
  padding-right: 20px !important;
}

.SettingsNav-module__p-r-30___MlxZ6 {
  padding-right: 30px !important;
}

.SettingsNav-module__p-r-50___uj5ie {
  padding-right: 50px !important;
}

.SettingsNav-module__p-r-60___kZwg3 {
  padding-right: 60px !important;
}

.SettingsNav-module__m-b-1___swCRs {
  margin-bottom: 1px !important;
}

.SettingsNav-module__m-b-2___Shc3r {
  margin-bottom: 2px !important;
}

.SettingsNav-module__m-b-6___y7JaH {
  margin-bottom: 6px !important;
}

.SettingsNav-module__m-b-8___Llird {
  margin-bottom: 8px !important;
}

.SettingsNav-module__m-b-10___Qsiw1 {
  margin-bottom: 10px !important;
}

.SettingsNav-module__m-b-14___Kls9m {
  margin-bottom: 14px !important;
}

.SettingsNav-module__m-b-16___I7TED {
  margin-bottom: 16px !important;
}

.SettingsNav-module__m-b-20___UTPj4 {
  margin-bottom: 20px !important;
}

.SettingsNav-module__m-b-22___J9iW8 {
  margin-bottom: 22px !important;
}

.SettingsNav-module__m-b-24___mztzY {
  margin-bottom: 24px !important;
}

.SettingsNav-module__m-b-30___Cl9DL {
  margin-bottom: 30px !important;
}

.SettingsNav-module__m-b-32___ZnJoi {
  margin-bottom: 32px !important;
}

.SettingsNav-module__m-b-40___xCqLn {
  margin-bottom: 40px !important;
}

.SettingsNav-module__m-t-2___x59Zu {
  margin-top: 2px !important;
}

.SettingsNav-module__m-t-3___D4YMb {
  margin-top: 3px !important;
}

.SettingsNav-module__m-t-4___VL9kh {
  margin-top: 4px !important;
}

.SettingsNav-module__m-t-5____Ewiy {
  margin-top: 5px !important;
}

.SettingsNav-module__m-t-8___m81cd {
  margin-top: 8px !important;
}

.SettingsNav-module__m-t-10___vVGdg {
  margin-top: 10px !important;
}

.SettingsNav-module__m-t-15___VOECU {
  margin-top: 15px !important;
}

.SettingsNav-module__m-t-16___VYtVe {
  margin-top: 16px !important;
}

.SettingsNav-module__m-t-20___t4Ytb {
  margin-top: 20px !important;
}

.SettingsNav-module__m-t-22___FwMYr {
  margin-top: 22px !important;
}

.SettingsNav-module__m-t-30___Cu03i {
  margin-top: 30px !important;
}

.SettingsNav-module__m-t-32___P1EHd {
  margin-top: 32px !important;
}

.SettingsNav-module__m-l-auto___R5cBU {
  margin-left: auto !important;
}

.SettingsNav-module__m-l-4___OFM_8 {
  margin-left: 4px !important;
}

.SettingsNav-module__m-l-5___pgH_v {
  margin-left: 5px !important;
}

.SettingsNav-module__m-l-6___TFCCS {
  margin-left: 6px !important;
}

.SettingsNav-module__m-l-8___nucNV {
  margin-left: 8px !important;
}

.SettingsNav-module__m-l-10___dRfAl {
  margin-left: 10px !important;
}

.SettingsNav-module__m-l-16___ek7wS {
  margin-left: 16px !important;
}

.SettingsNav-module__m-l-20___l4S6D {
  margin-left: 20px !important;
}

.SettingsNav-module__m-l-24___Puh2M {
  margin-left: 24px !important;
}

.SettingsNav-module__m-l-30___Sqc1y {
  margin-left: 30px !important;
}

.SettingsNav-module__m-l-35___jbAVr {
  margin-left: 35px !important;
}

.SettingsNav-module__m-l-40___kKeV7 {
  margin-left: 40px !important;
}

.SettingsNav-module__m-r-8___tQUiw {
  margin-right: 8px !important;
}

.SettingsNav-module__m-r-10___cYhlq {
  margin-right: 10px !important;
}

.SettingsNav-module__m-r-16___wLtGB {
  margin-right: 16px !important;
}

.SettingsNav-module__m-r-20___s2p29 {
  margin-right: 20px !important;
}

.SettingsNav-module__m-r-24___m_dLM {
  margin-right: 24px !important;
}

.SettingsNav-module__m-r-30___YzSgJ {
  margin-right: 30px !important;
}

.SettingsNav-module__m-r-40___r4ST5 {
  margin-right: 40px !important;
}

.SettingsNav-module__border-r-3___SlYRT {
  border-radius: 3px !important;
}

.SettingsNav-module__border-r-4___oXaMb {
  border-radius: 4px !important;
}

.SettingsNav-module__border-r-6___p7ghj {
  border-radius: 6px !important;
}

.SettingsNav-module__border-r-10___Sb2Sw {
  border-radius: 10px !important;
}

.SettingsNav-module__border-r-12___UEmgO {
  border-radius: 12px !important;
}

.SettingsNav-module__border-r-16___ysyzk {
  border-radius: 16px !important;
}

.SettingsNav-module__border-r-50___GKteF {
  border-radius: 50% !important;
}

.SettingsNav-module__primary-border___hG78y {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SettingsNav-module__primary-border-b___Y37YP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SettingsNav-module__primary-border-t___MijgC {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SettingsNav-module__primary-border-l___Jq2s7 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SettingsNav-module__primary-border-r___CtmVE {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SettingsNav-module__secondary-border___A83sV {
  border: 1px solid #637768;
}

.SettingsNav-module__secondary-border-b___kA8Ef {
  border-bottom: 1px solid #637768;
}

.SettingsNav-module__secondary-border-t___EMFcl {
  border-top: 1px solid #637768;
}

.SettingsNav-module__secondary-border-l___WbdSD {
  border-left: 1px solid #637768;
}

.SettingsNav-module__secondary-border-r___au7QR {
  border-right: 1px solid #637768;
}

.SettingsNav-module__gap-0___cdoUM {
  gap: 0 !important;
}

.SettingsNav-module__gap-2___ExwnV {
  gap: 2px !important;
}

.SettingsNav-module__gap-4___ZjJ_J {
  gap: 4px !important;
}

.SettingsNav-module__gap-5___wouiu {
  gap: 5px !important;
}

.SettingsNav-module__gap-6___v8XEE {
  gap: 6px !important;
}

.SettingsNav-module__gap-8___iXr_Q {
  gap: 8px !important;
}

.SettingsNav-module__gap-10___pabs0 {
  gap: 10px !important;
}

.SettingsNav-module__gap-12___FIrjH {
  gap: 12px !important;
}

.SettingsNav-module__gap-14___Xbxm5 {
  gap: 14px !important;
}

.SettingsNav-module__gap-16___UAj9u {
  gap: 16px !important;
}

.SettingsNav-module__gap-18___uCpS3 {
  gap: 18px !important;
}

.SettingsNav-module__gap-20___KICFM {
  gap: 20px !important;
}

.SettingsNav-module__gap-24___PHcKN {
  gap: 24px !important;
}

.SettingsNav-module__gap-26___zAQSY {
  gap: 26px !important;
}

.SettingsNav-module__gap-30___Cs1UB {
  gap: 30px !important;
}

.SettingsNav-module__gap-32___Nkonh {
  gap: 32px !important;
}

.SettingsNav-module__gap-40___E_EUY {
  gap: 40px !important;
}

.SettingsNav-module__gap-50___uuPlW {
  gap: 50px !important;
}

.SettingsNav-module__flex-1___upfw_ {
  flex: 1;
}

.SettingsNav-module__flex-none___CsOAs {
  flex: none !important;
}

.SettingsNav-module__flex-column___QRhh1 {
  display: flex;
  flex-direction: column !important;
}

.SettingsNav-module__flex-row___A5bcx {
  display: flex;
  flex-direction: row !important;
}

.SettingsNav-module__vertically-centered___FZT_X {
  display: flex;
  align-items: center !important;
}

.SettingsNav-module__horizontally-centered___cOyhn {
  display: flex;
  justify-content: center !important;
}

.SettingsNav-module__horizontally-end___W2BjG {
  display: flex;
  justify-content: end !important;
}

.SettingsNav-module__vertically-start___DH_dy {
  display: flex;
  align-items: start !important;
}

.SettingsNav-module__space-between___bv7eW {
  display: flex;
  justify-content: space-between !important;
}

.SettingsNav-module__flex-wrap___EXAlv {
  flex-wrap: wrap !important;
}

.SettingsNav-module__height-100___VIkAq {
  height: 100%;
}

.SettingsNav-module__width-50___sjyxK {
  width: 50% !important;
}

.SettingsNav-module__width-100___y0BAa {
  width: 100%;
}

.SettingsNav-module__cursor-pointer___mg2fL {
  cursor: pointer;
}

.SettingsNav-module__cursor-not-allowed___hYb_8 {
  cursor: not-allowed !important;
}

.SettingsNav-module__absolute-centered___l7rDY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SettingsNav-module__absolute___vIyA6 {
  position: absolute;
}

.SettingsNav-module__relative___ZC8aF {
  position: relative;
}

.SettingsNav-module__fixed___hcPBX {
  position: fixed;
}

.SettingsNav-module__visible___K7DP1 {
  opacity: 1;
}

.SettingsNav-module__invisible___mIRWi {
  opacity: 0;
}

.SettingsNav-module__col-90___uu4Xn {
  width: 90% !important;
}

.SettingsNav-module__col-auto___pClFT {
  width: auto !important;
}

.SettingsNav-module__medical-tabs___rUiPB {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SettingsNav-module__medical-table-new___Ziib3 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SettingsNav-module__medical-table-new___Ziib3:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SettingsNav-module__medical-table-new___Ziib3::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SettingsNav-module__medical-table-new___Ziib3::-webkit-scrollbar-track {
  display: none;
}
.SettingsNav-module__medical-table-new___Ziib3.SettingsNav-module__no-pagination___i4SnE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SettingsNav-module__medical-table-new___Ziib3.SettingsNav-module__no-pagination___i4SnE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SettingsNav-module__medical-table-new___Ziib3.SettingsNav-module__no-pagination___i4SnE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SettingsNav-module__medical-table-new___Ziib3.SettingsNav-module__no-pagination___i4SnE::-webkit-scrollbar-track {
  display: none;
}

.SettingsNav-module__medical-table-empty___iJQSZ {
  padding: 14px 40px !important;
}

.SettingsNav-module__icon-btn___SyEmv {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SettingsNav-module__search-icon___dF371 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SettingsNav-module__disable-select___Hr01Z {
  user-select: none;
}

.SettingsNav-module__break-word___W97gF {
  word-break: break-word;
}

.SettingsNav-module__popup-clear-btn___zcCRJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SettingsNav-module__scroll-m-b-20___McaPk {
  scroll-margin-bottom: 20px;
}

.SettingsNav-module__nav___Mu22S {
  height: 100%;
  background-color: white;
  gap: 24px;
}
.SettingsNav-module__nav___Mu22S a {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 0.9rem;
  color: #6d7278;
  transition: color 0.4s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.SettingsNav-module__nav___Mu22S a:hover {
  color: black;
}
.SettingsNav-module__nav___Mu22S a.SettingsNav-module__active___swcJb {
  color: black;
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 0.9rem;
}
.SettingsNav-module__nav___Mu22S .SettingsNav-module__text___DJwGi {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 0.9rem;
  color: #6d7278;
}
.SettingsNav-module__nav___Mu22S .SettingsNav-module__text___DJwGi > a:first-child {
  margin-top: 10px;
}
.SettingsNav-module__nav___Mu22S .SettingsNav-module__text___DJwGi > a {
  padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Settings/SettingsNav/SettingsNav.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,uBAAA;EACA,SAAA;AA8pBF;AA5pBE;EEmBA,+BApBO;EAqBP,gBCzBQ;ED0BR,iBAAA;EFnBE,cAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAgqBJ;AA9pBI;EACE,YAAA;AAgqBN;AA7pBI;EACE,YAAA;EEMJ,+BApBO;EAqBP,gBCxBO;EDyBP,iBAAA;AF0pBF;AA7pBE;EECA,+BApBO;EAqBP,gBCzBQ;ED0BR,iBAAA;EFDE,cAAA;AAiqBJ;AA/pBI;EACE,gBAAA;AAiqBN;AA9pBI;EACE,iBAAA;AAgqBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.nav {\n  height: 100%;\n  background-color: get-color(white);\n  gap: 24px;\n\n  a {\n    @include get-font($roboto, $regular, small);\n    color: get-color(gray, dark);\n    transition: color 0.4s ease;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    &:hover {\n      color: get-color(black);\n    }\n\n    &.active {\n      color: get-color(black);\n      @include get-font($roboto, $medium, small);\n    }\n  }\n\n  .text {\n    @include get-font($roboto, $regular, small);\n    color: get-color(gray, dark);\n\n    & > a:first-child {\n      margin-top: 10px;\n    }\n\n    & > a {\n      padding: 5px 10px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SettingsNav-module__font-s-10___tsQVZ`,
	"fontS12": `SettingsNav-module__font-s-12___WRvLY`,
	"fontS13": `SettingsNav-module__font-s-13___Y_eOl`,
	"fontS14": `SettingsNav-module__font-s-14___yJC0v`,
	"fontS15": `SettingsNav-module__font-s-15___LJjcc`,
	"fontS16": `SettingsNav-module__font-s-16___C0juE`,
	"fontS18": `SettingsNav-module__font-s-18___ivtWK`,
	"fontS20": `SettingsNav-module__font-s-20___TwNCL`,
	"fontS22": `SettingsNav-module__font-s-22___y_7OX`,
	"fontS28": `SettingsNav-module__font-s-28___siAVF`,
	"fontW400": `SettingsNav-module__font-w-400___lD0VM`,
	"fontW500": `SettingsNav-module__font-w-500___mjPBm`,
	"fontW600": `SettingsNav-module__font-w-600___j7Ng_`,
	"fontW700": `SettingsNav-module__font-w-700___tyKpa`,
	"p5": `SettingsNav-module__p-5___JsQyk`,
	"p12": `SettingsNav-module__p-12___v1Fhm`,
	"p16": `SettingsNav-module__p-16___JMjBi`,
	"p30": `SettingsNav-module__p-30___dZ6yN`,
	"pB0": `SettingsNav-module__p-b-0___ZMYEm`,
	"pB5": `SettingsNav-module__p-b-5___GO1Ik`,
	"pB10": `SettingsNav-module__p-b-10___Kgcd3`,
	"pB12": `SettingsNav-module__p-b-12___CnWxa`,
	"pB16": `SettingsNav-module__p-b-16___r9GyU`,
	"pB18": `SettingsNav-module__p-b-18___FuB84`,
	"pB20": `SettingsNav-module__p-b-20___CrxZG`,
	"pB25": `SettingsNav-module__p-b-25___kSVIz`,
	"pB30": `SettingsNav-module__p-b-30___pHdba`,
	"pB50": `SettingsNav-module__p-b-50___Xar5q`,
	"pT0": `SettingsNav-module__p-t-0___eUX9_`,
	"pT12": `SettingsNav-module__p-t-12___hAipe`,
	"pT16": `SettingsNav-module__p-t-16___PWV5B`,
	"pT18": `SettingsNav-module__p-t-18___Kvomf`,
	"pT20": `SettingsNav-module__p-t-20___DNtQ5`,
	"pT30": `SettingsNav-module__p-t-30___f8qln`,
	"pT40": `SettingsNav-module__p-t-40___b1uwU`,
	"pT50": `SettingsNav-module__p-t-50___XAuHj`,
	"pL20": `SettingsNav-module__p-l-20___i39Md`,
	"pL30": `SettingsNav-module__p-l-30___wAv7E`,
	"pL40": `SettingsNav-module__p-l-40___HcReb`,
	"pR16": `SettingsNav-module__p-r-16___xU5Of`,
	"pR20": `SettingsNav-module__p-r-20___SglaR`,
	"pR30": `SettingsNav-module__p-r-30___MlxZ6`,
	"pR50": `SettingsNav-module__p-r-50___uj5ie`,
	"pR60": `SettingsNav-module__p-r-60___kZwg3`,
	"mB1": `SettingsNav-module__m-b-1___swCRs`,
	"mB2": `SettingsNav-module__m-b-2___Shc3r`,
	"mB6": `SettingsNav-module__m-b-6___y7JaH`,
	"mB8": `SettingsNav-module__m-b-8___Llird`,
	"mB10": `SettingsNav-module__m-b-10___Qsiw1`,
	"mB14": `SettingsNav-module__m-b-14___Kls9m`,
	"mB16": `SettingsNav-module__m-b-16___I7TED`,
	"mB20": `SettingsNav-module__m-b-20___UTPj4`,
	"mB22": `SettingsNav-module__m-b-22___J9iW8`,
	"mB24": `SettingsNav-module__m-b-24___mztzY`,
	"mB30": `SettingsNav-module__m-b-30___Cl9DL`,
	"mB32": `SettingsNav-module__m-b-32___ZnJoi`,
	"mB40": `SettingsNav-module__m-b-40___xCqLn`,
	"mT2": `SettingsNav-module__m-t-2___x59Zu`,
	"mT3": `SettingsNav-module__m-t-3___D4YMb`,
	"mT4": `SettingsNav-module__m-t-4___VL9kh`,
	"mT5": `SettingsNav-module__m-t-5____Ewiy`,
	"mT8": `SettingsNav-module__m-t-8___m81cd`,
	"mT10": `SettingsNav-module__m-t-10___vVGdg`,
	"mT15": `SettingsNav-module__m-t-15___VOECU`,
	"mT16": `SettingsNav-module__m-t-16___VYtVe`,
	"mT20": `SettingsNav-module__m-t-20___t4Ytb`,
	"mT22": `SettingsNav-module__m-t-22___FwMYr`,
	"mT30": `SettingsNav-module__m-t-30___Cu03i`,
	"mT32": `SettingsNav-module__m-t-32___P1EHd`,
	"mLAuto": `SettingsNav-module__m-l-auto___R5cBU`,
	"mL4": `SettingsNav-module__m-l-4___OFM_8`,
	"mL5": `SettingsNav-module__m-l-5___pgH_v`,
	"mL6": `SettingsNav-module__m-l-6___TFCCS`,
	"mL8": `SettingsNav-module__m-l-8___nucNV`,
	"mL10": `SettingsNav-module__m-l-10___dRfAl`,
	"mL16": `SettingsNav-module__m-l-16___ek7wS`,
	"mL20": `SettingsNav-module__m-l-20___l4S6D`,
	"mL24": `SettingsNav-module__m-l-24___Puh2M`,
	"mL30": `SettingsNav-module__m-l-30___Sqc1y`,
	"mL35": `SettingsNav-module__m-l-35___jbAVr`,
	"mL40": `SettingsNav-module__m-l-40___kKeV7`,
	"mR8": `SettingsNav-module__m-r-8___tQUiw`,
	"mR10": `SettingsNav-module__m-r-10___cYhlq`,
	"mR16": `SettingsNav-module__m-r-16___wLtGB`,
	"mR20": `SettingsNav-module__m-r-20___s2p29`,
	"mR24": `SettingsNav-module__m-r-24___m_dLM`,
	"mR30": `SettingsNav-module__m-r-30___YzSgJ`,
	"mR40": `SettingsNav-module__m-r-40___r4ST5`,
	"borderR3": `SettingsNav-module__border-r-3___SlYRT`,
	"borderR4": `SettingsNav-module__border-r-4___oXaMb`,
	"borderR6": `SettingsNav-module__border-r-6___p7ghj`,
	"borderR10": `SettingsNav-module__border-r-10___Sb2Sw`,
	"borderR12": `SettingsNav-module__border-r-12___UEmgO`,
	"borderR16": `SettingsNav-module__border-r-16___ysyzk`,
	"borderR50": `SettingsNav-module__border-r-50___GKteF`,
	"primaryBorder": `SettingsNav-module__primary-border___hG78y`,
	"primaryBorderB": `SettingsNav-module__primary-border-b___Y37YP`,
	"primaryBorderT": `SettingsNav-module__primary-border-t___MijgC`,
	"primaryBorderL": `SettingsNav-module__primary-border-l___Jq2s7`,
	"primaryBorderR": `SettingsNav-module__primary-border-r___CtmVE`,
	"secondaryBorder": `SettingsNav-module__secondary-border___A83sV`,
	"secondaryBorderB": `SettingsNav-module__secondary-border-b___kA8Ef`,
	"secondaryBorderT": `SettingsNav-module__secondary-border-t___EMFcl`,
	"secondaryBorderL": `SettingsNav-module__secondary-border-l___WbdSD`,
	"secondaryBorderR": `SettingsNav-module__secondary-border-r___au7QR`,
	"gap0": `SettingsNav-module__gap-0___cdoUM`,
	"gap2": `SettingsNav-module__gap-2___ExwnV`,
	"gap4": `SettingsNav-module__gap-4___ZjJ_J`,
	"gap5": `SettingsNav-module__gap-5___wouiu`,
	"gap6": `SettingsNav-module__gap-6___v8XEE`,
	"gap8": `SettingsNav-module__gap-8___iXr_Q`,
	"gap10": `SettingsNav-module__gap-10___pabs0`,
	"gap12": `SettingsNav-module__gap-12___FIrjH`,
	"gap14": `SettingsNav-module__gap-14___Xbxm5`,
	"gap16": `SettingsNav-module__gap-16___UAj9u`,
	"gap18": `SettingsNav-module__gap-18___uCpS3`,
	"gap20": `SettingsNav-module__gap-20___KICFM`,
	"gap24": `SettingsNav-module__gap-24___PHcKN`,
	"gap26": `SettingsNav-module__gap-26___zAQSY`,
	"gap30": `SettingsNav-module__gap-30___Cs1UB`,
	"gap32": `SettingsNav-module__gap-32___Nkonh`,
	"gap40": `SettingsNav-module__gap-40___E_EUY`,
	"gap50": `SettingsNav-module__gap-50___uuPlW`,
	"flex1": `SettingsNav-module__flex-1___upfw_`,
	"flexNone": `SettingsNav-module__flex-none___CsOAs`,
	"flexColumn": `SettingsNav-module__flex-column___QRhh1`,
	"flexRow": `SettingsNav-module__flex-row___A5bcx`,
	"verticallyCentered": `SettingsNav-module__vertically-centered___FZT_X`,
	"horizontallyCentered": `SettingsNav-module__horizontally-centered___cOyhn`,
	"horizontallyEnd": `SettingsNav-module__horizontally-end___W2BjG`,
	"verticallyStart": `SettingsNav-module__vertically-start___DH_dy`,
	"spaceBetween": `SettingsNav-module__space-between___bv7eW`,
	"flexWrap": `SettingsNav-module__flex-wrap___EXAlv`,
	"height100": `SettingsNav-module__height-100___VIkAq`,
	"width50": `SettingsNav-module__width-50___sjyxK`,
	"width100": `SettingsNav-module__width-100___y0BAa`,
	"cursorPointer": `SettingsNav-module__cursor-pointer___mg2fL`,
	"cursorNotAllowed": `SettingsNav-module__cursor-not-allowed___hYb_8`,
	"absoluteCentered": `SettingsNav-module__absolute-centered___l7rDY`,
	"absolute": `SettingsNav-module__absolute___vIyA6`,
	"relative": `SettingsNav-module__relative___ZC8aF`,
	"fixed": `SettingsNav-module__fixed___hcPBX`,
	"visible": `SettingsNav-module__visible___K7DP1`,
	"invisible": `SettingsNav-module__invisible___mIRWi`,
	"col90": `SettingsNav-module__col-90___uu4Xn`,
	"colAuto": `SettingsNav-module__col-auto___pClFT`,
	"medicalTabs": `SettingsNav-module__medical-tabs___rUiPB`,
	"medicalTableNew": `SettingsNav-module__medical-table-new___Ziib3`,
	"noPagination": `SettingsNav-module__no-pagination___i4SnE`,
	"medicalTableEmpty": `SettingsNav-module__medical-table-empty___iJQSZ`,
	"iconBtn": `SettingsNav-module__icon-btn___SyEmv`,
	"searchIcon": `SettingsNav-module__search-icon___dF371`,
	"disableSelect": `SettingsNav-module__disable-select___Hr01Z`,
	"breakWord": `SettingsNav-module__break-word___W97gF`,
	"popupClearBtn": `SettingsNav-module__popup-clear-btn___zcCRJ`,
	"scrollMB20": `SettingsNav-module__scroll-m-b-20___McaPk`,
	"nav": `SettingsNav-module__nav___Mu22S`,
	"active": `SettingsNav-module__active___swcJb`,
	"text": `SettingsNav-module__text___DJwGi`
};
module.exports = ___CSS_LOADER_EXPORT___;
